import { CONTACTS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(CONTACTS_ENDPOINT);
export default instance;
